/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class Wholesaler {
    wholesaler_key: number;
    crNum: number;
    wholesalerEntityName: string;
    wholesalerTradeAsName: string;
    licenseNo: string;
    streetAddr1: string;
    streetAddr2: string;
    city: string;
    state: string;
    zipCode: string;
    phone: string;
    updatedBy: string;
    lastUpdate: Date;
    comments: string;
}
